import { HTTPService } from 'fides-angularjs-components/src/fts-services/fts-http-service';
import { USER_ACC_REPORTS, USER_ACC, USER_ACC_SUMMARIES } from './arsweb/RoutingPaths';

export class AccountService {
    constructor(userService) {
        this.service = new HTTPService(userService.fsMainDependencies);
    }

    getUserData(restUrl) {
        return this.service.useGetHandler(USER_ACC + restUrl);
    }

    getUserSummaryData(restUrl) {
        return this.service.useGetHandler(USER_ACC_SUMMARIES + restUrl);
    }

    postBinaryUserReport(restUrl, requestBody) {
        return this.service.useBinaryPostHandler(USER_ACC_REPORTS+ restUrl, requestBody);
    }

    postUserData(restUrl, requestBody) {
        return this.service.post(USER_ACC + restUrl, requestBody);
    }

    postUserReport(restUrl, requestBody) {
        return this.service.post(USER_ACC_REPORTS + restUrl, requestBody);
    }

    putUserData(restUrl, requestBody) {
        return this.service.put(USER_ACC + restUrl, requestBody);
    }

    deleteUserData(restUrl) {
        return this.service.delete(USER_ACC + restUrl);
    }
}
